import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addNew } from '../redux/booking/actions';

const BookButton = (flight) => {
  const flights = useSelector((state) => state);
  const dispatch = useDispatch();

  const { from, to, date, guests, ticketClass } = flight;

  const addNewFlight = (e) => {
    e.preventDefault();

    if (from && to && date && guests && ticketClass) {
      dispatch(addNew(flight));
    }
  };

  return (
    <button
      className="addCity"
      type="submit"
      id="lws-addCity"
      onClick={addNewFlight}
      disabled={flights.length >= 3}
    >
      <svg
        width="15px"
        height="15px"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="2"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 4.5v15m7.5-7.5h-15"
        />
      </svg>
      <span className="text-sm">Book</span>
    </button>
  );
};

export default BookButton;
